//@flow
import BaseComponent from '../base_component/base_component'

export default class ContactUs extends BaseComponent {

    constructor(id: number, component_name: string, options: any) {
        super(id, component_name, options);

        $('body').on('click', '#contact-form-submit', () => {
            if  (this.validForm()) {
                this.startRequest();
                this.submitForm().done( () => { this.finishRequest() });
            }
            return false;
        })
    }

    validForm() {
        let acceptedPrivacyPolicy = $('#compliance-1').is(":checked");
        let hasEmail = $('#contact_email').val();
        if (!hasEmail) {
            this.displayRequiredLabel('#email-required-span');
            $('#contact_email').css({"border": "2px solid red"});
            return false;
        } else if (!acceptedPrivacyPolicy) {
            this.displayRequiredLabel('#compliance-required-span');
            return false;
        }
        return true;
    }

    displayRequiredLabel(id: string) {
        $(id).css("display", "inline-block");
    }

    startRequest() {
        $('#contact-form-submit i').remove();
        $('#contact-form-submit').append(' <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>')
    }

    submitForm(){
        let firstName = $('#contact_first_name').val();
        let lastName = $('#contact_last_name').val();
        let email = $('#contact_email').val();
        let company = $('#contact_company').val();
        let mobileNumber = $('#contact_mobile_number').val();
        let message = $('#contact_message').val();
        let acceptedPrivacyPolicy = $('#compliance-1').is(":checked");
        let acceptedMbMarketing = $('#compliance-2').is(":checked");
        let acceptedMbGroupMarketing = $('#compliance-3').is(":checked");

        let headers: {[string]: any} = {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        };
        return $.ajax({
            type: "POST",
            url: '/contact_us',
            dataType: 'json',
            data: JSON.stringify({
                'first_name': firstName,
                'last_name': lastName,
                'email': email,
                'company': company,
                'mobile_number': mobileNumber,
                'message': message,
                'accepted_privacy_policy': acceptedPrivacyPolicy
            }),
            contentType: 'application/json',
            headers: headers
        });
    }

    finishRequest() {
        $('.contact-form-inner').html(`
            <h2 class="form-title">Thank you for email, someone will reach out to you soon.</h2>
        `)
    }
}
